<template>
	<nk-wrapper v-if="context" spacing="md">
		<nk-form
			:success="success"
			:error="error"
			success-message="Vielen Dank für Ihre Anfrage!"
			success-description="Wir werden Ihre Anfrage so schnell wie möglich bearbeiten."
			error-message="Leider ist ein Fehler bei der Anfrage aufgetreten"
			:error-description="`Wir werden versuchen den Fehler schnellstmöglich zu
				beheben. Bitte wenden Sie sich in dringenden Fällen direkt
				<a href='mailto:${genericMail}'>per E-Mail</a>
				an uns.`"
			name="pauschalenanfrageformulare"
			:schema="schema"
			@submit="submitForm"
		/>

		<nk-wrapper spacing="md">
			<nk-text v-if="success">
				<nk-button @click.prevent="resetForm">Zurück zum Formular</nk-button>
			</nk-text>
		</nk-wrapper>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';
import {jumpTo} from '#imports';

export default {
	name: 'NkTemplateFormularPauschalenAnfrage',

	mixins: [TemplatesDefault],

	data() {
		const config = useRuntimeConfig();
		return {
			form: null,
			error: false,
			success: false,
			genericMail:
				config.public.NUXT_PUBLIC_FORM_RECEIVER_KONTAKT_GEMEINDE ||
				'info@webcontact.de',
		};
	},

	computed: {
		schema() {
			return [
				{
					component: 'h2',
					class: 'text-xl my-4',
					children: `${this.$route.query.pauschale} im ${this.$route.query.hotel}`,
					id: 'headline-1',
				},
				{
					component: 'div',
					class: 'flex flex-wrap -m-2',
					id: 'wrapper-1-1',
					children: [
						{
							component: 'div',
							class: 'w-full sm:w-6/12 p-2',
							id: 'col-1-1',
							children: [
								{
									type: 'text',
									label: 'Vorname',
									name: 'vorname',
									validation: '^required|min:2',
									'validation-messages': {
										required: `
											Bitte geben Sie Ihren Vornamen an.
										`,
									},
								},
							],
						},
						{
							component: 'div',
							class: 'w-full sm:w-6/12 p-2',
							id: 'col-1-2',
							children: [
								{
									type: 'text',
									label: 'Nachname',
									name: 'nachname',
									validation: '^required|min:2',
									'validation-messages': {
										required: `
											Bitte geben Sie Ihren Nachnamen an.
										`,
									},
								},
							],
						},
						{
							component: 'div',
							class: 'w-full p-2',
							id: 'col-4',
							children: [
								{
									type: 'text',
									label: 'Straße',
									placeholder: 'Musterstraße 11',
									name: 'strasse',
									validation: 'required',
								},
							],
						},
						{
							component: 'div',
							class: 'w-full sm:w-3/12 p-2',
							id: 'col-5',
							children: [
								{
									type: 'text',
									label: 'PLZ',
									placeholder: '12345',
									name: 'plz',
									validation: 'required',
								},
							],
						},
						{
							component: 'div',
							class: 'w-full sm:w-9/12 p-2',
							id: 'col-6',
							children: [
								{
									type: 'text',
									label: 'Ort',
									placeholder: 'Musterstadt',
									name: 'ort',
									validation: 'required',
								},
							],
						},
						{
							component: 'div',
							class: 'w-full sm:w-4/12 p-2',
							id: 'col-1-3',
							children: [
								{
									type: 'number',
									label: 'Anzahl der Personen',
									name: 'anzahl_personen',
									value: 2,
									validation: 'min:1',
									'validation-messages': {
										required: `
											Die minimale Personenanzahl beträgt 1
										`,
									},
								},
							],
						},
						{
							component: 'div',
							class: 'w-full sm:w-4/12 p-2',
							id: 'col-1-4',
							children: [
								{
									type: 'date',
									label: 'Datum von',
									name: 'datum_von',
									value: this.$moment().format('YYYY-MM-DD'),
									min: this.$moment().format('YYYY-MM-DD'),
									validation: 'required',
									'validation-messages': {
										required: `
											Bitte geben Sie an, an welchem Tag Sie anreisen möchten.
										`,
									},
								},
							],
						},
						{
							component: 'div',
							class: 'w-full sm:w-4/12 p-2',
							id: 'col-1-5',
							children: [
								{
									type: 'date',
									label: 'Datum bis',
									name: 'datum_bis',
									value: this.$moment().format('YYYY-MM-DD'),
									min: this.$moment().format('YYYY-MM-DD'),
									validation: 'required',
									'validation-messages': {
										required: `
											Bitte geben Sie an, an welchem Tag Sie abreisen möchten.
										`,
									},
								},
							],
						},
						{
							component: 'div',
							class: 'w-full sm:w-6/12 p-2',
							id: 'col-1-7',
							children: [
								{
									type: 'tel',
									label: 'Telefonnummer',
									placeholder: '+49 0123 4567',
									name: 'telefon',
								},
							],
						},
						{
							component: 'div',
							class: 'w-full sm:w-6/12 p-2',
							id: 'col-1-8',
							children: [
								{
									type: 'email',
									label: 'E-Mail Adresse',
									placeholder: 'max.mustermann@beispiel.de',
									name: 'email',
									validation: '^required|email',
									'validation-messages': {
										required: `
											Bitte geben Sie an, unter welcher Mailadresse wir mit Ihnen
											aufnehmen können. Die Mailadresse muss gültig sein. Format
											abc@xyz.de
										`,
									},
								},
							],
						},
						{
							component: 'div',
							class: 'w-full p-2',
							id: 'col-1-6',
							children: [
								{
									type: 'text',
									label: 'Bemerkung',
									name: 'bemerkung',
								},
							],
						},
					],
				},
				{
					component: 'h2',
					class: 'text-xl my-4',
					children: 'Datenschutzerklärung',
					id: 'headline-3',
				},
				{
					component: 'div',
					class: 'flex flex-wrap -m-2',
					id: 'wrapper-3',
					children: [
						{
							component: 'div',
							class: 'w-full p-2',
							id: 'col-3-1',
							children: [
								{
									type: 'consent',
									consent: `Ja, ich habe die <a href="${this.privacyLink()}" target="_blank" rel="noopener">Datenschutz­erklärung</a> zur Kenntnis genommen und bin damit einverstanden, dass die von mir angegebenen Daten elektronisch erhoben und gespeichert werden. Meine Daten werden dabei nur streng zweckgebunden zur Bearbeitung und Beantwortung meiner Anfrage genutzt. Ich kann meine Einwilligung jederzeit per E-Mail an <a href="mailto:${this.privacyEmail()}">${this.privacyEmail()}</a> widerrufen.`,
									name: 'datenschutz',
									class: 'text-sm',
									validation: 'required',
								},
							],
						},
					],
				},
				{
					component: 'hr',
					class: '',
				},
				{
					component: 'div',
					class: 'flex flex-wrap -m-2',
					id: 'wrapper-6',
					children: [
						{
							component: 'div',
							class: 'w-auto  p-2',
							id: 'col-6-1',
							children: [
								{
									type: 'submit',
									name: 'Anfrage abschicken',
								},
							],
						},
					],
				},
			];
		},
	},

	methods: {
		resetForm() {
			this.form = null;
			this.error = false;
			this.success = false;

			window.setTimeout(() => {
				const firstInput = this.$el.querySelector('input, select, button');

				jumpTo(firstInput);

				firstInput.focus();
			}, 250);
		},

		async submitForm(form) {
			this.form = form;

			if (this.form.firma && this.form.firma.length) {
				this.error = true;
				return false;
			}

			if (!this.$route.query.pauschale || !this.$route.query.hotel) {
				this.error = true;
				return false;
			}

			try {
				const mailResult = await this.$axios({
					method: 'POST',
					url: `/api/pauschalen/anfrage`,
					headers: {
						'Content-Type': 'application/json',
					},
					data: {
						...this.$route.query,
						...this.form,
						route: this.$route.path,
					},
				});

				if (!mailResult) {
					this.error = true;
					return false;
				}

				this.error = false;
				this.success = true;
				return true;
			} catch (err) {
				if (this.$sentry) {
					this.$sentry.captureException(err);
				}

				this.error = true;
				return false;
			}
		},

		privacyLink() {
			return this.options.privacyLink || '/datenschutz';
		},

		privacyEmail() {
			const config = useRuntimeConfig();
			return (
				this.options.privacyEmail ||
				config.public.NUXT_PUBLIC_FORM_RECEIVER_KONTAKT_GEMEINDE
			);
		},
	},
};
</script>
